<template lang="pug">
  .businnes-list-folder
    .list-folder-title Carpetas
    b-row(cols="1" cols-sm="2" cols-md="4" cols-lg="5" no-gutters)
      b-col(v-for="folder in folders")
        .folder-list-item(v-if="folder.isActive" :id="`folder-${folder.id}`" @click="goToFolder(folder.id)")
          font-awesome-icon(:icon="['fas', 'folder']")
          | {{folder.name}} {{folder.service?(' - '+folder.service.name):''}}
        b-tooltip.text(:target="`folder-${folder.id}`" triggers="hover" delay="300") {{folder.name}} {{folder.service?(' - '+folder.service.name):''}}

</template>

<script>

export default {
  props: {
    folders: {
      type: Array,
      default: () => []
    },
    service: Object
  },
  methods: {
    goToFolder(folderId) {
      const businessId = this.$route.params.businessId
      this.$router.push({ name: 'BusinessFolder', params: { businessId, folderId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-folder-title {
  font-weight: bold;
  margin-bottom: 16px;
}
.folder-list-item {
  svg {
    margin-right: 10px;
    width: 17px;
  }
  min-height: 60px;
  height: calc(100% - 0.5rem);
  cursor: pointer;
  color: #7F828F;
  margin: 0.25rem;
  padding: 10px 8px;
  border: 1px solid #E4E4E4;
  border-radius: 5px;
  font-size: 13px;
}
</style>
